import unsubscribe from './Unsubscribe';

export default unsubscribe;
